import React from "react";

export default function SettingTable() {
  return <div>SettingTable</div>;
}
